module.exports = __webpack_public_path__ + "static/media/3.b0310ca0.jpg";